/**
 * Tracks user-initiated reaction additions to differentiate from Pusher events.
 * This allows components to determine if a reaction was added by the current user
 * vs. received from another user via real-time updates.
 */

let userInitiatedReactionTimestamp: number | null = null;
const USER_REACTION_WINDOW_MS = 2000;

/**
 * Marks that the user has initiated adding/removing a reaction.
 * Should be called immediately when the user clicks a reaction button.
 */
export function markUserInitiatedReaction(): void {
  userInitiatedReactionTimestamp = Date.now();
}

/**
 * Checks if a reaction was recently initiated by the user.
 * Returns true if within the time window of a user-initiated reaction.
 */
export function isRecentUserInitiatedReaction(): boolean {
  if (userInitiatedReactionTimestamp === null) {
    return false;
  }

  const elapsed = Date.now() - userInitiatedReactionTimestamp;

  if (elapsed > USER_REACTION_WINDOW_MS) {
    userInitiatedReactionTimestamp = null;
    return false;
  }

  return true;
}

/**
 * Clears the user-initiated reaction flag.
 */
export function clearUserInitiatedReactionFlag(): void {
  userInitiatedReactionTimestamp = null;
}
